



















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Utils from '@/modules/Utils';
import PropUtils from '@/modules/PropUtils';

@Component({})
class GroupDeviceItem extends Vue {
    @Prop() index;
    @Prop({ default: () => ({}) }) source;
    @Prop({ default: false }) editable;
    @Prop({ default: () => ({}) }) isChecked;
    @Prop() updateDevices;

    get deviceName(){
        return this.source.name || '';
    }

    get location(){
        if (!this.source['meta.location']) return '';
        return Utils.deviceLocation(this.source);
    }

    getMetaField(field){
        return PropUtils.getMetaDeviceField(this.source['meta.device'], field);
    }

    onToggle(value){
        this.isChecked[this.source.id] = value;
        if (this.updateDevices) this.updateDevices(this.source);
    }
}

export default GroupDeviceItem;
